import { Branch } from 'src/components/GoogleMaps/GoogleMapsTypes';
import './styles/MapMarkerInfo.scss';

function googleMapsMarkerInfo(branch: Branch) {
    return `
        <div class="branch-bubble">
            <a href="${branch.url}" class="branch-bubble__title">${branch.name}</a>
            <address>
                ${branch.address.split(',').join('<br>')}
                ${branch.city ? `${branch.city}<br>` : ''}
                ${branch.state ? `${branch.state}<br>` : ''}
            </address>
            <a href="tel:${branch.telephone}" class="branch-bubble__phone">
                <b>Tel:</b> ${branch.telephone}
            </a>
            ${
                branch.url
                    ? `<a class="button button--small branch-bubble__btn" href="${branch.url}" title="More Info">More Info</a>`
                    : ''
            }
        </div>
    `;
}

export { googleMapsMarkerInfo };
